export default __webpack_public_path__ + "static/media/FKGroteskNeue-Regular.4e2ef3b7.woff";